<template lang="pug">
  .returned
    DataGrid(ref="grid" :fetch="fetchData")
      tr(slot="thead")
        th Code
        th Package
        th Product
        th User
        th Event Time
      tr(v-for="r in returned")
        td.kzcode-default {{r.code.code}}
        td {{r.packageType.name}}
        td {{r.product.name}}
        td {{r.user.username}}
        td {{r.timestamp | date}}
</template>

<script>
import DataGrid from '@/components/ssp/DataGrid'
import TrackNTrace from '@/service/apis/TrackNTrace'
import { dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    returned: null
  }),
  methods: {
    fetchData(page) {
      const req = page.pageRequest()
      return TrackNTrace.getLocationReturnes(this.locationId, req)
        .then((resp) => {
          this.returned = resp.data.content
          return resp.data.numberOfElements
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  computed: {
    locationId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/Returned.vue